<template>
    <div class="layout-footer">
        <div>
            <router-link to="/">
                <div
                    class="layout-topbar-logo"
                    id="logolink"
                    style="cursor: pointer; outline: none"
                >
                    <img v-if="authStore.selectedProduct !== null"
                        class="w-full h-3rem"
                        id="app-logo"
                        alt="product logo"
                        :src="require(`@/assets/images/logo/${authStore.selectedProduct}.png`)"
                    />
                </div>
            </router-link>
        </div>
        <div class="social-icons">
            <a
                href="https://www.ignistechnologies.co.uk/"
                target="_blank"
                v-tooltip="'Visit our website'"
            >
                <i class="pi pi-globe"></i>
            </a>

            <a
                href="https://www.facebook.com/profile.php?id=61568043800020"
                target="_blank"
                v-tooltip="'Visit our facebook page'"
            >
                <i class="pi pi-facebook"></i>
            </a>
            <!-- <a>
                <i class="pi pi-twitter"></i>
            </a>-->
            <a
                href="https://www.linkedin.com/company/ignistechnology/"
                target="_blank"
                v-tooltip="'Visit our linked page'"
            >
                <i class="pi pi-linkedin"></i>
            </a>
        </div>
    </div>
</template>

<script setup>
import { useAuthStore } from '@/modules/auth/store';

const authStore = useAuthStore();
</script>
